import { gql } from 'apollo-angular';

export default gql`
  query ListPrinters3DByTenantId($tenant_id: ID!) {
    listPrinters3DByTenantId(tenant_id: $tenant_id) {
      id
      tenant_id
      tenant_ref
      name
      description
      printer_slug
      sort_order
    }
  }

  query GetPrint3DLogByOrderId($order_id: ID!) {
    getPrint3DLogByOrderId(order_id: $order_id) {
      order_id
      status
      submitted_at
      started_at
      completed_at
      failed_at
      error_message
      runner_message_id
      input_prefix
      output_prefix
      print_attempt
      selected_printer_id
      selected_printer_name
    }
  }

  mutation CreatePrint3DJob($input: CreatePrint3DJobInput!) {
    createPrint3DJob_v2(input: $input) {
      order_id
      status
      message_id
    }
  }
`;
